(function () {
  function openHashTarget(root) {
    if (!window.location.hash) return;

    var target;
    try {
      target = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
    } catch (error) {
      return;
    }

    if (!target || !root.contains(target)) return;
    var details = target.matches('details') ? target : target.closest('details');
    if (details) details.open = true;
  }

  document.querySelectorAll('[data-tg-support-page]').forEach(function (root) {
    root.querySelectorAll('[data-tg-case-tab]').forEach(function (button) {
      button.addEventListener('click', function () {
        var group = button.closest('[data-tg-case-group]');
        if (!group) return;
        var key = button.getAttribute('data-tg-case-tab');

        group.querySelectorAll('[data-tg-case-tab]').forEach(function (item) {
          item.setAttribute('aria-selected', item === button ? 'true' : 'false');
          item.setAttribute('tabindex', item === button ? '0' : '-1');
        });
        group.querySelectorAll('[data-tg-case-panel]').forEach(function (panel) {
          var isActive = panel.getAttribute('data-tg-case-panel') === key;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      });

      button.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        var group = button.closest('[data-tg-case-group]');
        if (!group) return;
        var tabs = Array.from(group.querySelectorAll('[data-tg-case-tab]'));
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        var next = tabs[(tabs.indexOf(button) + direction + tabs.length) % tabs.length];
        event.preventDefault();
        next.click();
        next.focus();
      });
    });

    root.querySelectorAll('[data-tg-scroll-ai]').forEach(function (button) {
      button.addEventListener('click', function () {
        var intake = document.querySelector('[data-tg-support-intake]');
        var input = intake && intake.querySelector('[data-tg-si-input]');
        if (!intake || !input) return;
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        intake.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        window.setTimeout(function () { input.focus(); }, 350);
      });
    });

    openHashTarget(root);
  });

  window.addEventListener('hashchange', function () {
    document.querySelectorAll('[data-tg-support-page]').forEach(openHashTarget);
  });
})();
